import React from 'react';
import type { IconProps } from '@models/types';
import { styled } from '@mui/material/styles';

const Icon: React.FC<IconProps> = (props) => (
    <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            d='M19 4C20.6569 4 22 5.34315 22 7V17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V7C2 5.34315 3.34315 4 5 4H19ZM9.89844 11.1777C9.70593 10.8854 9.28009 10.8764 9.0752 11.1602L5.07227 16.707C4.83362 17.0377 5.06974 17.5 5.47754 17.5H18.3916C18.7763 17.4998 19.0175 17.0832 18.8252 16.75L17.0928 13.75C16.9003 13.4168 16.419 13.4168 16.2266 13.75L14.4668 16.7988C14.2807 17.1205 13.8207 17.1337 13.6162 16.8232L9.89844 11.1777ZM16 6C14.8954 6 14 6.89543 14 8C14 9.10457 14.8954 10 16 10C17.1044 9.99975 18 9.10442 18 8C18 6.89558 17.1044 6.00025 16 6Z'
            fill='currentColor'
        />
    </svg>
);

export const ImageIcon = styled(Icon)({});
